export const backendUrl = 'https://backend.sourceandsolutionbd.com/'
export const spacesBucketUrl = 'https://sns.sgp1.cdn.digitaloceanspaces.com/'
